import React, { useState } from "react";
import { FiShield, FiChevronDown, FiChevronUp, FiPlus, FiX } from "react-icons/fi";
import '../css/Components.css';

const CLIENT_LIST = ["Aramco", "ADNOC", "KNPC", "PDO", "Other"];

const ClientSpecificApproval = ({ value = { clients: [], otherClients: [] }, onChange, readOnly = false }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [otherInput, setOtherInput] = useState("");

  const toggle = (client) => {
    if (readOnly) return;
    const already = value.clients.includes(client);
    const clients = already
      ? value.clients.filter((c) => c !== client)
      : [...value.clients, client];
    const patch = { ...value, clients };
    if (client === "Other" && already) patch.otherClients = [];
    onChange?.(patch);
  };

  const addOther = () => {
    const name = otherInput.trim();
    if (!name) return;
    onChange?.({ ...value, otherClients: [...(value.otherClients || []), name] });
    setOtherInput("");
  };

  const removeOther = (idx) => {
    onChange?.({ ...value, otherClients: value.otherClients.filter((_, i) => i !== idx) });
  };

  const selectedCount = value.clients.length + (value.otherClients?.length || 0);

  return (
    <div className="competency-wrapper">
      <div
        className="competency-header"
        onClick={() => setCollapsed((c) => !c)}
        style={{ cursor: "pointer" }}
      >
        <h2>
          <FiShield /> Client Specific Approval
          {selectedCount > 0 && (
            <span style={{
              marginLeft: 8, background: "#1a2a4d", color: "#fff",
              borderRadius: 10, padding: "1px 8px", fontSize: 11, fontWeight: 600,
            }}>
              {selectedCount} selected
            </span>
          )}
        </h2>
        <span>{collapsed ? <FiChevronDown /> : <FiChevronUp />}</span>
      </div>

      {!collapsed && (
        <div className="discipline-section">
          <div className="discipline-header" style={{ cursor: "default" }}>
            <strong>Clients</strong>
          </div>

          <div className="grid-table" style={{ padding: 0 }}>
            {CLIENT_LIST.map((client) => (
              <label key={client} className="checkbox-item">
                <input
                  type="checkbox"
                  checked={value.clients.includes(client)}
                  onChange={() => toggle(client)}
                  disabled={readOnly}
                />
                {client}
              </label>
            ))}
            {/* Custom "Other" clients shown directly in the grid alongside predefined ones */}
            {(value.otherClients || []).map((name, idx) => (
              <label key={`other-${idx}`} className="checkbox-item" style={{ background: "#f0f4ff" }}>
                <input
                  type="checkbox"
                  checked={true}
                  onChange={() => !readOnly && removeOther(idx)}
                  disabled={readOnly}
                />
                {name}
                {!readOnly && (
                  <button
                    type="button"
                    onClick={(e) => { e.preventDefault(); removeOther(idx); }}
                    style={{ background: "none", border: "none", cursor: "pointer", color: "#999", padding: "0 0 0 4px", lineHeight: 1 }}
                  >
                    <FiX size={10} />
                  </button>
                )}
              </label>
            ))}
          </div>

          {value.clients.includes("Other") && !readOnly && (
            <div style={{ padding: "10px 14px 14px" }}>
              <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                <input
                  className="cust-input"
                  type="text"
                  placeholder="Enter client name"
                  value={otherInput}
                  onChange={(e) => setOtherInput(e.target.value)}
                  onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); addOther(); } }}
                  style={{ maxWidth: 240 }}
                />
                <button
                  type="button"
                  className="cust-btn cust-btn-green"
                  onClick={addOther}
                  style={{ whiteSpace: "nowrap" }}
                >
                  <FiPlus size={11} /> Add
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ClientSpecificApproval;
